var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"loginContainer"},[_c('button',{staticClass:"btnSURREALMLogin",on:{"click":_vm.testOpenID}},[_vm._v("OpenID Login")])]),_c('div',{staticClass:"loginBackgroundM"})])}
var staticRenderFns = []

export { render, staticRenderFns }